import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import style from "./spinner.module.scss";
import React from "react";

/**
 *
 * @param {boolean}loading
 * @param {boolean}fullscreen
 * @param icon
 * @param {boolean}spin
 * @param {boolean}pulse
 * @param {number} size
 * @param {"opacity"|"visibility"} mode
 * @param children
 * @return {JSX.Element|null}
 * @constructor
 */
export default function LoadingIcon({
  loading,
  fullscreen = true,
  icon = "spinner-third",
  spin = true,
  pulse = false,
  size = 5,
  mode = "visibility",
  children,
}) {
  return null;
  if (loading || mode === "opacity") {
    return (
      <div
        className={`d-flex flex-column align-items-center justify-content-center ${
          fullscreen ? "bg-white h-100 w-100 position-absolute" : ""
        }`}
        style={{ opacity: !loading ? 0 : 1 }}
      >
        <FontAwesomeIcon
          icon={icon}
          className={`m-3 loadingSpinner " ${pulse ? style.pulsing : ""}`}
          style={{ fontSize: size + "rem" }}
          spin={pulse ? false : spin}
        />
        {children}
      </div>
    );
  } else return null;
}
